import Vue from 'vue'
import App from './App.vue'
import './assets/css/style.css'
// import ElementUI from 'element-ui';
import './assets/iconfont/iconfont.js'
import dgUI from "./components/index";
import router from "./router";
import ajax from "./assets/js/axios/index";
import mirror from "./assets/js/mirror.js";
Vue.config.productionTip = false
Vue.use(dgUI);
import wow from 'wowjs'
window.ajax = ajax;
window.Mirror = mirror;
Vue.prototype.$wow = wow
/**
 * 动态引入js
 * @param {*} src
 */
const injectScript = (srcs, callback) => {
  const loadNextScript = (index) => {
    if (index >= srcs.length) {
      // 所有 src 都加载失败
      console.error("所有脚本加载失败");
      return;
    }
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = srcs[index];
    const t = document.getElementsByTagName("script")[0];
    t.parentNode.insertBefore(s, t);
    s.onload = function () {
      // 当前脚本加载成功，调用回调函数
      callback && callback();
    };

    s.onerror = function () {
      // 当前脚本加载失败，尝试加载下一个脚本
      console.error(`脚本 ${srcs[index]} 加载失败，尝试加载下一个`);
      loadNextScript(index + 1);
    };
  };

  // 开始加载第一个脚本
  loadNextScript(0);
};
window.Vue = Vue;
injectScript(['./index.js'], () => {
 

  new Vue({
    router,
    render: h => h(App),
  }).$mount('#app')

});


